export default {
  lines: [
    {
      fromName: '阿巴嘎旗',
      toName: '勐海县',
      coords: [
        [
          114.971,
          44.0227,
        ],
        [
          100.448,
          21.9559,
        ],
      ],
      count: 1,
    },
    {
      fromName: '阿巴嘎旗',
      toName: '矿区',
      coords: [
        [
          114.971,
          44.0227,
        ],
        [
          113.559,
          37.8701,
        ],
      ],
      count: 11,
    },
    {
      fromName: '阿巴嘎旗',
      toName: '濮阳县',
      coords: [
        [
          114.971,
          44.0227,
        ],
        [
          115.024,
          35.7104,
        ],
      ],
      count: 3,
    },
    {
      fromName: '阿巴嘎旗',
      toName: '山海关区',
      coords: [
        [
          114.971,
          44.0227,
        ],
        [
          119.754,
          39.998,
        ],
      ],
      count: 1,
    },
    {
      fromName: '阿巴嘎旗',
      toName: '叶城县',
      coords: [
        [
          114.971,
          44.0227,
        ],
        [
          77.4203,
          37.8847,
        ],
      ],
      count: 124,
    },
    {
      fromName: '山海关',
      toName: '叶城县',
      coords: [
        [
          119.754,
          39.998,
        ],
        [
          77.4203,
          37.8847,
        ],
      ],
      count: 4,
    },
  ],
  tooltip: {
    show: true,
    formatter: (param) => {
      return `<div>位置：${param.data.fromName}→${param.data.toName}</div><div>数量：${param.data.count}头</div>`;
    },
    shadowBlur: 10,
    borderColor: 'rgba(0,0,0,0.5)',
    backgroundColor: 'rgba(0,0,0,0.5)',
    textStyle: {
      color: '#fff',
    },
  },
};
